/* esm.sh - @radix-ui/react-use-callback-ref@1.1.1 */
import*as e from"react";function u(t){let c=e.useRef(t);return e.useEffect(()=>{c.current=t}),e.useMemo(()=>(...r)=>c.current?.(...r),[])}export{u as useCallbackRef};
//# sourceMappingURL=react-use-callback-ref.mjs.map